import React, { useContext, useEffect, useState, useRef } from 'react';
import { Modal, message, Form, Input, Select, InputNumber, Checkbox, Upload } from 'antd';
import { Context } from '../../../defaults';
import { updateQuestion } from '../../../actions';
import JoditEditor from 'jodit-react';
import Dragger from 'antd/lib/upload/Dragger';
import { InboxOutlined } from '@ant-design/icons';
import TestQuestion from './TestQuestion';
import OpenQuestion from './OpenQuestion';
import DropAndDragQuestion from './DropAndDragQuestion';
import MissingWordsQuestion from './MissingWordsQuestion';
import { positiveIntegerRegex } from '../../../common';
import { ViewDocument } from '../../../components';

export function QuestionsModal({
  modalProps,
  languagesType,
  closeModal,
  questionLevels,
  questionType,
}) {
  const { actionType, visible, currentQuestion } = modalProps;
  const { dictionary, language, setLoading } = useContext(Context);
  const [form] = Form.useForm();
  const [withFile, setWithFile] = useState(false);

  const [multiQuestionAnswerFiles, setMultiQuestionAnswerFiles] = useState([
    { index: 0, fileLists: [] },
  ]);

  const modalTitle = `${dictionary?.EditQuestion[language]}`;
  const requiredMessage = `${dictionary?.RequiredField[language]}`;
  const editor = useRef(null);
  const config = {
    readonly: false,
    limitChars: 2000,
  };

  const initialState = {
    name: '',
    description: '',
    langId: '',
    institutionId: null,
    studyYear: null,
  };

  console.log(actionType);
  console.log(currentQuestion);

  useEffect(() => {
    actionType === 'edit' && form.setFieldsValue(currentQuestion);
  }, [actionType, currentQuestion, form]);

  const updateQuestions = () => {
    if (currentQuestion.questionTypeId === 1) {
      if (form.getFieldValue('tests').some((el) => !!el.isRight)) {
        return updateQuestion({
          ...form.getFieldsValue(),
          answerVariants: form.getFieldValue('tests').map((el) => {
            return { ...el, isRight: el.isRight === true ? 1 : 0 };
          }),
        });
      } else {
        message.error(dictionary?.OnlyOneAnswerCountValidation[language], 4);
      }
    } else if (currentQuestion.questionTypeId === 2) {
      return updateQuestion({
        ...form.getFieldsValue(),
        answerVariants: [
          {
            isRight: 1,
            answerHtml: form.getFieldValue('answerHtml'),
            id: form.getFieldValue('answerId'),
          },
        ],
      });
    } else if (currentQuestion.questionTypeId === 3) {
      return updateQuestion({
        ...form.getFieldsValue(),
        answerVariants: form.getFieldValue('sorts').map((el, index) => {
          return { ...el, sortOrder: index };
        }),
      });
    } else if (currentQuestion.questionTypeId === 4) {
      return updateQuestion({
        ...form.getFieldsValue(),
        answerVariants: form.getFieldValue('missingWords').map((el, index) => {
          return { ...el, answerText: el.answerText, sortOrder: index };
        }),
      });
    } else if (currentQuestion.questionTypeId === 5) {
      if (form.getFieldValue('missingWords').some((el) => !!el.isRight)) {
        return updateQuestion({
          ...form.getFieldsValue(),
          answerVariants: form.getFieldValue('missingWords').map((el, index) => {
            return { ...el, sortOrder: index, isRight: el.isRight === true ? 1 : 0 };
          }),
        });
      } else {
        message.error(dictionary?.MinAnswerCountValidation[language], 4);
      }
    }
  };

  const onUpdateQuestions = () => {
    setLoading(true);
    updateQuestions()
      .then((response) => {
        setLoading(false);
        message.success(dictionary?.SuccessfullyChanged[language], 4);
        form.resetFields();
        closeModal();
      })
      .catch(() => {
        message.error(dictionary?.SomethingWentWrong[language], 4);
        setLoading(false);
        closeModal();
      });
  };

  return (
    <Modal
      title={modalTitle}
      visible={visible}
      onOk={onUpdateQuestions}
      onCancel={() => closeModal()}
      okText={dictionary?.Save[language]}
      cancelText={dictionary?.Cancel[language]}
      width={1000}>
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 14 }}
        layout="horizontal"
        initialValues={actionType === 'edit' ? currentQuestion : initialState}>
        <Form.Item name="subjectId" style={{ display: 'none' }}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="topicId" style={{ display: 'none' }}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="yearOfStudy" style={{ display: 'none' }}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="langId" style={{ display: 'none' }}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="questionTypeId" style={{ display: 'none' }}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="teacherId" style={{ display: 'none' }}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item name="id" style={{ display: 'none' }}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item
          name="questionHtml"
          label={dictionary?.Question[language]}
          rules={[
            {
              required: true,
            },
            {
              max: 2000,
              type: 'string',
              message: dictionary?.MaxCharacterCount[language].replace('%s', 2000),
            },
          ]}>
          <JoditEditor ref={editor} config={config} tabIndex={1} />
        </Form.Item>

        {
          !!currentQuestion && currentQuestion.files && currentQuestion.files.length > 0 &&
          <Form.Item
            label={dictionary?.File[language]}
          >
            <ViewDocument files={currentQuestion.files} />

          </Form.Item>}

        {currentQuestion && currentQuestion.questionTypeId === 1 && (
          <TestQuestion
            dictionary={dictionary}
            language={language}
            form={form}
            Answers={currentQuestion.answerVariants}
            multiQuestionAnswerFiles={multiQuestionAnswerFiles}
            setMultiQuestionAnswerFiles={setMultiQuestionAnswerFiles}
          />
        )}
        {currentQuestion && currentQuestion.questionTypeId === 2 && (
          <OpenQuestion
            dictionary={dictionary}
            language={language}
            form={form}
            Answers={currentQuestion.answerVariants}
            currentQuestion={currentQuestion}
          />
        )}
        {currentQuestion && currentQuestion.questionTypeId === 3 && (
          <DropAndDragQuestion
            dictionary={dictionary}
            language={language}
            form={form}
            Answers={currentQuestion.answerVariants}
            multiQuestionAnswerFiles={multiQuestionAnswerFiles}
            setMultiQuestionAnswerFiles={setMultiQuestionAnswerFiles}
          />
        )}
        {currentQuestion && currentQuestion.questionTypeId === 4 && (
          <MissingWordsQuestion
            dictionary={dictionary}
            language={language}
            form={form}
            Answers={currentQuestion.answerVariants}
          />
        )}
        {currentQuestion && currentQuestion.questionTypeId === 5 && (
          <MissingWordsQuestion
            dictionary={dictionary}
            language={language}
            form={form}
            Answers={currentQuestion.answerVariants}
            withChecking={true}
          />
        )}
        <Form.Item
          name="questionLevel"
          label={dictionary?.Level[language]}
          rules={[
            {
              required: true,
            },
          ]}>
          <Select>
            {questionLevels &&
              questionLevels.map((el) => {
                return (
                  <Select.Option value={el.level} key={el.level}>
                    {el.description}
                  </Select.Option>
                );
              })}
          </Select>
        </Form.Item>
        <Form.Item
          name="point"
          label={dictionary?.Point[language]}
          rules={[
            { required: true },
            { pattern: positiveIntegerRegex, message: dictionary?.OnlyNumber[language] },
          ]}>
          <InputNumber />
        </Form.Item>
        <Form.Item name="comment" label={dictionary?.Comment[language]}>
          <Input />
        </Form.Item>
        <Form.Item name="hintText" label={dictionary?.Hint[language]}>
          <Input />
        </Form.Item>
        <Form.Item
          name="hintPoint"
          label={dictionary?.HintPoint[language]}
          rules={[{ pattern: positiveIntegerRegex, message: dictionary?.OnlyNumber[language] }]}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}
